const INTERNAL_ORIGIN = 'https://lagshoppen.local'

export const getValidatedInternalPath = (rawPath?: string | null): string | null => {
  if (!rawPath || !rawPath.startsWith('/') || rawPath.startsWith('//')) {
    return null
  }

  try {
    const parsed = new URL(rawPath, INTERNAL_ORIGIN)
    if (parsed.origin !== INTERNAL_ORIGIN) {
      return null
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}

export const canRoleAccessPath = (
  role: string | undefined,
  path: string
): boolean => {
  if (!role) {
    return false
  }

  try {
    const pathname = new URL(path, INTERNAL_ORIGIN).pathname

    switch (role) {
      case 'lead':
        return (
          pathname === '/intyg' ||
          pathname.startsWith('/my-team') ||
          pathname === '/packning' ||
          pathname.startsWith('/packning/')
        )
      case 'member':
        return (
          pathname === '/intyg' ||
          pathname.startsWith('/member') ||
          pathname === '/packning' ||
          pathname.startsWith('/packning/')
        )
      case 'club_supervisor':
        return pathname.startsWith('/my-club')
      case 'admin':
        return pathname.startsWith('/admin')
      default:
        return false
    }
  } catch {
    return false
  }
}

/** Reads returnTo (packning CTA) or redirectTo (PrivateSet unauthenticated redirect). */
export const getLoginRedirectFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search)
  const raw = params.get('returnTo') ?? params.get('redirectTo')
  return getValidatedInternalPath(raw)
}

export const canRoleUseLoginRedirect = (
  role: string | undefined,
  redirectPath: string
) => canRoleAccessPath(role, redirectPath)
